<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { isWallDisplay, real_id } from '../../../helpers/interface_helpers';
	import { getErrorOrInfoMessageForMinAndMax } from '../../../helpers/utilities';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import {
		buildHumiditySetConfigParams,
		usesVentoraMergedSensorSetConfig,
	} from '../../../helpers/sensor_config_helpers';
	//Services
	import { gen2Request } from '../../../services/gen_2_http_reqs';
	//Design system components
	import { Button, Input, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';

	export let device: Device;

	const id = real_id(device.id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	const min = 1;
	$: max = !isWallDisplay(device.type) ? 20 : 50;

	let value = settings?.['humidity:0']?.report_thr;
	let waitForResponse = false;

	const save = async () => {
		waitForResponse = true;
		const params = usesVentoraMergedSensorSetConfig(device)
			? buildHumiditySetConfigParams(settings, device.channel, {
					report_thr: value,
				})
			: {
					id: device.channel,
					config: { report_thr: value },
				};

		const res = await gen2Request(device, 'Humidity.SetConfig', params);
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: inputData = getErrorOrInfoMessageForMinAndMax(value, min, max);
</script>

<Text styleType="body-small" class="mb-s"
	>{$format('humidity_threshold_description', {
		default:
			'Threshold for triggering a device wake up. Relative Humidity change with more than the specified value triggers the device to report sensor data',
	})}</Text
>

<Input
	size="m"
	class="mb-s"
	icon="fas fa-calculator"
	bind:value
	info={inputData.info}
	error={inputData.error}
	type="number"
	step={1}
	id="input-44hx0lf"
	aria-label={$format('sub_settings_title_humidity_threshold', {
		default: 'Humidity threshold',
	})}
/>

<Button size="m" width="full" loading={waitForResponse} disabled={inputData.error} on:click={save}>
	{$format('button_save', { default: 'Save' })}
</Button>
